import { Pathname } from "./pathname";

export const PathnameGenerator = (name: string) => {
  return Pathname.DASHBOARD_QUOTES + name;
};

export const PathnameQuotes = {
  LANDING_PAGE: "/",
  QUOTES: "/test",
};
